export default {"src":"https://webcdn.trailways.com/_next/static/media/facebook.6f68a4a2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};